/* global modUtils */
export const trackTimeOnPage = {
	start: function() {
		const startTime = Date.now();
		modUtils.setCookie('startTime', startTime);
	},
	complete: function() {
		const startTime = Number(modUtils.getCookie('startTime'));
		if (startTime && !isNaN(startTime)) {
			const endTime = Date.now();
			const timeSpent = endTime - startTime;
			const formattedTime = trackTimeOnPage.formatTime(timeSpent);
			modUtils.deleteCookie('startTime');
			return formattedTime;
		}
	},
	formatTime: function(ms) {
		if (!ms || isNaN(ms)) {
			return 'unknown';
		}

		const sec = Math.floor(ms / 1000);
		const min = Math.floor(sec / 60);
		const hrs = Math.floor(min / 60);
		return `${String(hrs).padStart(2, '0')}:${String(min % 60).padStart(2, '0')}:${String(sec % 60).padStart(2, '0')}`;
	}
};
